



























import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import { useThemeStore } from "@/shared/store/theme";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";

@Component({
  components: {
    GenericLoadingSpinner
  }
})
export default class ContributionConfirmationModal extends Vue {
  themeStore = useThemeStore();
  accepted = false;
  submitting = false;

  @Prop({required: true})
  confirmModalVisible: boolean;

  onCancel (): void {
    this.accepted = false;
    this.$emit("cancel");
  }

  onSubmit (): void {
    this.submitting = true;
    this.$emit("confirm-contribution");
  }
}
